import { useQuery } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { credentialKeys } from './queryKeys';

export const useGetCredentialHooks = (hookIds: ID[]) =>
  useQuery({
    queryKey: credentialKeys.hooks(hookIds),
    queryFn: () =>
      api.unpaginatedRequest(endpoints.hooks.list)({ id: hookIds }),
    enabled: hookIds.length > 0,
  });
